import { render, staticRenderFns } from "./BankOrderIndex.vue?vue&type=template&id=526bc03c&scoped=true"
import script from "./BankOrderIndex.vue?vue&type=script&lang=js"
export * from "./BankOrderIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526bc03c",
  null
  
)

export default component.exports